module.exports = __webpack_public_path__ + "img/C2_HQ03.346b0c0e.jpg";